import {ConfigProvider} from 'antd';
import 'antd/dist/antd.css';
import enUS from 'antd/lib/locale-provider/en_US';
import {createBrowserHistory} from 'history';
import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import * as ReactDOM from 'react-dom';
import {Router, Switch} from 'react-router';
import {client} from './api/graphql';
import {Application, CallbackRoute, FullscreenLoader, PrivateRoute} from './components';
import './index.css';
import {registerServiceWorker} from './utils';

const history = createBrowserHistory();

ReactDOM.render(
  <ApolloProvider client={client}>
    <ConfigProvider locale={enUS}>
      <Router history={history}>
        <Switch>
          <CallbackRoute path="/callback" component={FullscreenLoader} />
          <PrivateRoute path="" component={Application} />
        </Switch>
      </Router>
    </ConfigProvider>
  </ApolloProvider>,
  document.getElementById('root') as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx